var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button-container"},_vm._l((_vm.options),function(option){return _c('VButton',{key:option.id,staticClass:"radio-button",attrs:{"on-click":() => _vm.onChange(option),"type":_vm.selectedId===option.id ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(option.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }